import { render, staticRenderFns } from "./AccountingAssign.vue?vue&type=template&id=550ad4f8"
import script from "./AccountingAssign.vue?vue&type=script&lang=js"
export * from "./AccountingAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports